import axios from 'axios';

export const NOT_FOUND_ROUTE = '/error/404';

/**
 * Ressource introuvable détectée côté front (ex. : commande absente de la liste du client).
 */
export class NotFoundError extends Error {
  constructor(message = 'Resource not found') {
    super(message);
    this.name = 'NotFoundError';
  }
}

/**
 * Le backend répond 404 quand la ressource n'existe pas ou n'appartient pas au périmètre client
 * de l'utilisateur (on ne révèle pas son existence).
 */
export const isNotFoundError = (error: unknown): boolean =>
  error instanceof NotFoundError || (axios.isAxiosError(error) && error.response?.status === 404);
